import { createApplicationState } from './applicationState';
import { sentryConfiguration } from './sentryConfiguration';
import { renderApplication } from './renderApplication';
import { initializeGeoLinks } from '../geo_links';

export const runApp = () => {
  sentryConfiguration();

  const store = createApplicationState();
  renderApplication(store);

  initializeGeoLinks();
};
